module.exports = __webpack_public_path__ + "static/assets/8f78304ce79a13f3093b295fbf0212d3.png";